import { BaseComponentProps } from '@utils/types/baseComponents';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import Checkbox from '@components/_shared/checkbox';
import { AmenityV2Enum } from '@components/_shared/amenityV2/constants';

const options = [
  'gym',
  'indoor_fireplace',
  'elevator',
  'garden_or_backyard',
  'patio_or_balcony',
  'doorman',
];

type Props = {
  onChange: (selectedValues: string[]) => void;
  value?: string[];
} & BaseComponentProps;

AmenitiesSelection.defaultProps = {};

export function AmenitiesSelection(props: Props) {
  const { containerStyle, onChange, value } = props;
  const [selectedOptions, setSelectedOptions] = useState<string[]>(value ?? []);

  const optionSelected = (option: string) => {
    setSelectedOptions((prevSelectedOptions: string[]) => {
      const newSelection = [...prevSelectedOptions];
      const index = newSelection.indexOf(option);
      if (index !== -1) {
        newSelection.splice(index, 1);
      } else {
        newSelection.push(option);
      }
      onChange(newSelection);
      return newSelection;
    });
  };

  useEffect(() => {
    if (value) {
      setSelectedOptions(value);
    }
  }, [value]);

  return (
    <div className={clsx([styles.amenitiesSelection, containerStyle])}>
      <div className={styles.title}>Amenities</div>
      <div className={styles.optionsList}>
        {options.map((v: string, idx: number) => (
          <Checkbox
            label={AmenityV2Enum[v as keyof typeof AmenityV2Enum]}
            key={idx}
            containerStyle={styles.option}
            onChange={() => optionSelected(v)}
            value={selectedOptions.includes(v)}
          />
        ))}
      </div>
    </div>
  );
}
